/** Texto plano para mensajes del copiloto: quita Markdown residual del modelo. */
export function formatCopilotPlainText(text: string): string {
  const bounded = text.slice(0, 50_000);
  return bounded
    .replace(/\*\*([^*]+)\*\*/g, '$1')
    .replace(/\*([^*]+)\*/g, '$1')
    .replace(/^#{1,6}\s+/gm, '')
    .replace(/`([^`]+)`/g, '$1')
    .replace(/^[-*]\s+/gm, '- ')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
